export default "__VITE_ASSET__Bs7y8xV$__"